import { render, staticRenderFns } from "./AttachmentsBlock.vue?vue&type=template&id=23e64b8f&scoped=true&"
import script from "./AttachmentsBlock.vue?vue&type=script&lang=js&"
export * from "./AttachmentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsBlock.vue?vue&type=style&index=0&id=23e64b8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e64b8f",
  null
  
)

export default component.exports